import { init as init$1 } from '@sentry/browser';
import { applySdkMetadata, setTag } from '@sentry/core';

/**
 * Initializes the client side of the React Router SDK.
 */
function init(options) {
  const opts = {
    ...options,
  };

  applySdkMetadata(opts, 'react-router', ['react-router', 'browser']);

  const client = init$1(opts);

  setTag('runtime', 'browser');

  return client;
}

export { init };
//# sourceMappingURL=sdk.js.map
